export const socialMediaLinks = {
  twitter: process.env.REACT_APP_TWITTER_URL || 'https://twitter.com/footydrafthub',
  instagram: process.env.REACT_APP_INSTAGRAM_URL || 'https://instagram.com/footydrafthub',
  facebook: process.env.REACT_APP_FACEBOOK_URL || 'https://facebook.com/footydrafthub',
  youtube: process.env.REACT_APP_YOUTUBE_URL || 'https://youtube.com/@footydrafthub'
}; 